import * as _gv from './_gv';
import * as _hm from './_hm';
import * as _ht from './_ht';

export const s = (
  size: _ht.n
) => {
  const _gUserz = _gv.useUserz();
  const _n = (size ?? 0) * (_gUserz.crt.scl ?? 8);
  //_hm.l(`cmSCL 9: ${size}, ${_gUserz.crt.scl}, ${_n}`);
  return _n;
};
